import RenderDashboard from '../../../components/RenderDashboard';

const AdminDashboard = () => {
  return <RenderDashboard type={'overview'}/>;
};


export default AdminDashboard;
